import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'

export class GetNotFilteredIceCatCategoryApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'MyReports/GetNotFilteredIceCatCategory',

      requesterInfo,
    })
  }

  public async getNotFilteredIceCatCategory(): Promise<any[]> {
    return await this.getAsync<any[]>()
  }
}
